<template>
	<section class="section product-details">
		<Loading :active.sync="loading"></Loading>
		<div class="columns is-multiline is-centered">
			<div class="column column-image is-5-tablet is-4-desktop is-4-widescreen is-4-fullhd is-relative">
				<router-link v-if="$store.getters.getFilters.category" class="button back" :to="{
						name: 'ProductsByCategory',
						params: { maincategory: $store.getters.getFilters.category }
						}">
					<b-icon icon="chevron-left" size="is-small"></b-icon>
					<span>{{ $t('Back') }}</span>
				</router-link>
				<router-link v-else class="button back" :to="{ name: 'Products' }">
					<b-icon icon="chevron-left" size="is-small"></b-icon>
					<span>{{ $t('Back') }}</span>
				</router-link>
				<template>
					<section v-if="product.Images[0]">
						<ProductGallery
							:_images="images"
							:_alt="
								$i18n.locale == 'hu'
									? product.name
									: typeof product.long_description != 'undefined' && product.long_description.en.name
										? product.long_description.en.name
										: product.name
							"
						></ProductGallery>
					</section>
					<section v-else>
						<img src="@/assets/images/placeholder_720.png" :alt="$t('placeholder image')" />
					</section>
				</template>
			</div>
			<div class="column column-bid is-7-tablet is-6-desktop is-4-widescreen is-4-fullhd">
				<div :class="flashClass">
					<div class="card-content">
						<h1 class="title has-text-grey-darker has-half-margin">
							{{
								$i18n.locale == 'hu'
									? product.name
									: typeof product.long_description != 'undefined' && product.long_description.en.name
										? product.long_description.en.name
										: product.name
							}}
						</h1>
						<p class="has-text-right has-half-margin">#{{ product.sku }} {{ $t('item') }}</p>
						<template>
							<div class="buttons buttons-actions is-block has-half-margin">
								<b-tooltip
									class="is-mg-right-1"
									:label="
										$store.getters.loggedIn == true
											? $t('Add to favorites')
											: $t('Add to favorites') + ' (' + $t('Login needed') + ')'
									"
									v-if="!isWishlisted"
								>
									<b-button
										:aria-label="
											$store.getters.loggedIn == true
												? $t('Add to favorites')
												: $t('Add to favorites') + ' (' + $t('Login needed') + ')'
										"
										type="is-primary"
										outlined
										:disabled="$store.getters.loggedIn != true"
										@click="AddToFavorites(bid)"
										icon-right="heart"
									>
									</b-button>
								</b-tooltip>
								<b-tooltip
									class="is-mg-right-1"
									:label="
										$store.getters.loggedIn == true
											? $t('Remove from favorites')
											: $t('Remove from favorites') + '(' + $t('Login needed') + ')'
									"
									v-else
								>
									<b-button
										:aria-label="
											$store.getters.loggedIn == true
												? $t('Remove from favorites')
												: $t('Remove from favorites') + '(' + $t('Login needed') + ')'
										"
										type="is-danger"
										outlined
										:disabled="$store.getters.loggedIn != true"
										@click="AddToFavorites(bid)"
										icon-right="heart"
									>
									</b-button>
								</b-tooltip>
								<b-tooltip
									v-for="button in buttons"
									v-if="button.type != 'purchase_order' || time.diff(product.Bid.finish) < -24*60*60*1000"
									:key="button.email"
									:label="
										$store.getters.loggedIn == true
											? $t(button.title)
											: $t(button.title) + ' (' + $t('Login needed') + ')'
									"
									:type="button.tooltipclass"
								>
									<b-button
										:aria-label="
											$store.getters.loggedIn == true
												? $t(button.title)
												: $t(button.title) + ' (' + $t('Login needed') + ')'
										"
										:type="button.class"
										@click="modalOpen(button)"
										:disabled="$store.getters.loggedIn != true"
										:icon-right="button.icon"
									>
									</b-button>
								</b-tooltip>
								<b-tooltip
									v-if="product.Bid.Auction.status == 'active' || product.Bid.Auction.status == 'finished'" class="is-hidden-tablet is-pulled-right"
									:label="$store.getters.loggedIn == true ? $t('Bid history') : $t('Bid history') + ' (' + $t('Login needed') + ')'"
									type="is-primary"
									position="is-left"
								>
									<b-button
										:aria-label="$store.getters.loggedIn == true ? $t('Bid history') : $t('Bid history') + ' (' + $t('Login needed') + ')'"
										type="is-primary"
										outlined
										icon-right="gavel"
										:disabled="$store.getters.loggedIn != true"
										@click="isBetModalActive = true"
									>
									</b-button>
								</b-tooltip>
								<b-tooltip
									v-if="product.Bid.Auction.status == 'active' || product.Bid.Auction.status == 'finished'" class="is-hidden-mobile is-pulled-right"
									:label="$store.getters.loggedIn == true ? '' : $t('Login needed')"
									type="is-primary"
								>
									<b-button
										type="is-primary"
										outlined
										icon-right="gavel"
										:disabled="$store.getters.loggedIn != true"
										@click="isBetModalActive = true"
									>
										<span>{{ $t('Bid history') }}</span>
									</b-button>
								</b-tooltip>
							</div>

							<b-modal :active.sync="isModalActive" :width="640" has-modal-card scroll="keep">
								<ProductForm :modalData="modalData" :product="product"></ProductForm>
							</b-modal>
						</template>
						<div class="content is-marginless">
							<div v-if="product.Bid.Auction.status == 'active' || product.Bid.Auction.status == 'finished'">
								<div v-if="time.diff(product.Bid.finish) < 0">
									<div class="columns is-mobile is-gapless">
										<div class="column">{{ $t('Expected closing') }}:</div>
										<div class="column is-narrow has-text-right">
											{{ bid.finish | moment }}
										</div>
									</div>
								</div>
								<div v-else>
									<div class="columns is-mobile is-gapless">
										<div class="column">{{ $t('Finished') }}:</div>
										<div class="column is-narrow has-text-right">
											{{ bid.finish | moment }}
										</div>
									</div>
								</div>

								<div class="columns is-marginless is-mobile is-gapless">
									<div class="column">{{ $t('Winning user') }}:</div>
									<div class="column is-narrow has-text-right">
										{{ is_winner_user }}
									</div>
								</div>

								<div class="columns is-marginless is-mobile is-gapless" v-if="lastBet.price > 0">
									<div class="column">{{ $t('Your maximum bid') }}:</div>
									<div class="column is-narrow has-text-right">
										{{ lastBet.price | toCurrency(this, currency) }}
									</div>
								</div>

								<div class="columns is-marginless is-mobile is-gapless">
									<div class="column">{{ $t('Bid step') }}:</div>
									<div class="column is-narrow has-text-right">
										{{ bid.bid_step | toCurrency(this, currency) }}
									</div>
								</div>
								<h3
									class="counter-title has-text-centered"
									v-if="product.Bid && product.Bid.Auction.status == 'active'"
								>
								<div v-if="false">
									FIXME {{ timerIsRun }} / {{ heartbeat }} / {{ time.diff(product.Bid.finish) }}<br/>
									{{ this.$moment().format('YYYY-MM-DD HH:mm:ss') }}<br/>
									{{ this.$moment().add(durationTime).format('YYYY-MM-DD HH:mm:ss') }}<br/>
									{{ durationTime }}<br/>
									FIXME
								</div>
								<span v-if="!timerIsRun && beatcounter > 0" class="is-danger">
									{{ $t('Warning! Server is not reachable.') }}
								</span>
								<span v-else>
									{{ 0 > time.diff(product.Bid.finish) ? remTimeFormat(time, product.Bid.finish) : '-' }}
								</span>
								</h3>
								<h3
									class="counter-title has-text-centered"
									v-else-if="product.Bid.Auction.status == 'visible' && time.diff(product.Bid.finish) < 0"
								>
									{{ $t('Coming soon') }}
								</h3>
								<h3 class="counter-title has-text-centered" v-else>{{ $t('Auction is closed') }}</h3>
								<div
									v-if="(product.Bid.Auction.status == 'active' || product.Bid.Auction.status == 'finished' )&& bid.winner_id !== null"
									class="columns box price-box is-mobile is-gapless"
								>
									<h4 v-if="product.Bid.Auction.status == 'finished'" class="column has-text-weight-bold">{{ $t('Buyout price') }}:</h4>
									<h4 v-else class="column has-text-weight-bold">{{ $t('Current price') }}:</h4>
									<h4
									v-bind:class="{
										'has-text-success': $store.getters.loggedIn && is_winner,
										'has-text-danger': $store.getters.loggedIn && !is_winner }"
									class="column is-narrow has-text-right has-text-weight-bold">
									<transition v-if="!$store.getters.loggedIn" name="slide-fade" mode="out-in">
										<div :key="bid.price">
											{{ bid.price | toCurrency(this, currency) }}
										</div>
									</transition>
									<div v-else>
										{{ bid.price | toCurrency(this, currency) }}
									</div>
									</h4>
								</div>
								<div v-else class="columns box price-box is-mobile is-gapless has-text-weight-bold">
									<h4 class="column has-text-weight-bold">{{ $t('Opening price') }}:</h4>
									<h4 class="column is-narrow has-text-right">
										{{ product.price | toCurrency(this, currency) }}
									</h4>
								</div>
								<div v-if="is_winner" class="has-text-success user-message has-text-centered">
									<span v-if="time.diff(product.Bid.finish) < 0">{{ $t('Your bid is winning now.') }}</span>
									<span v-else>{{ $t('You won the product.') }}</span>
								</div>
								<div
									v-if="!is_winner && lastBet.price > 0" class="has-text-danger user-message has-text-centered">
									{{ $t('You were overbid.') }}
								</div>
							</div>
							<div v-else-if="product.Bid.Auction.status == 'visible'" class="content has-text-weight-bold">
								<div class="columns is-mobile is-gapless">
									<div class="column">{{ $t('Opening price') }}:</div>
									<div class="column is-narrow has-text-right">
										{{ product.price | toCurrency(this, currency) }}
									</div>
								</div>
							</div>
							<div v-else class="content has-text-weight-bold">
								<div class="columns is-mobile is-gapless">
									<div class="column">{{ $t('Finished') }}:</div>
									<div class="column is-narrow has-text-right">
										{{ bid.finish | moment }}
									</div>
								</div>
								<div class="columns is-mobile is-gapless">
									<div class="column">{{ $t('Opening price') }}:</div>
									<div class="column is-narrow has-text-right">
										{{ product.price | toCurrency(this, currency) }}
									</div>
								</div>
							</div>
						</div>
						<!-- check if not finished -->
						<section
							id="bidbox"
							class="has-text-centered"
							v-if="
								$store.getters.loggedIn === true &&
								product.Bid &&
								time.diff(product.Bid.finish) < 0 &&
								product.Bid.Auction.status == 'active'
							"
						>
							<div v-if="(timerIsRun) && $store.getters.loggedIn == true && product.Bid.Auction.status == 'active'">
									<div class="control is-hidden-mobile">
										<b-switch
											v-on:click.native="fastBidEnable()"
											v-model="fastBidEnabled"
											:rounded="false"
											:outlined="false"
										>{{$t('Instant bid')}}</b-switch>
									</div>
								<div class="buttons buttons-fastbid has-addons">
									<b-button
										v-on:click="sendLicit(hufToCurrency(fastbid1), new_bid.currency)"
										type="is-primary"
										:disabled="fastBidEnabled?false:'disabled'"
										outlined
										>{{ hufToCurrency(fastbid1) | fmtCurrency(currency) }}</b-button
									>
									<b-button
										v-on:click="sendLicit(hufToCurrency(fastbid2), new_bid.currency)"
										type="is-primary"
										:disabled="fastBidEnabled?false:'disabled'"
										outlined
										>{{ hufToCurrency(fastbid2) | fmtCurrency(currency) }}</b-button
									>
									<b-button
										v-on:click="sendLicit(hufToCurrency(fastbid3), new_bid.currency)"
										type="is-primary"
										:disabled="fastBidEnabled?false:'disabled'"
										outlined
										>{{ hufToCurrency(fastbid3) | fmtCurrency(currency) }}</b-button
									>
								</div>

								<b-field type="is-primary" grouped>
									<b-input
										type="number"
										custom-class="bidfield"
										@keypress="isNumber($event)"
										v-on:keypress.enter.native="sendLicit(new_bid.price, currency)"
										v-model="new_bid.price"
										:step="1"
										expanded
									></b-input>
									<div class="control place-bid">
										<b-button v-on:click="sendLicit(new_bid.price, currency)" type="is-primary">{{
											$t('Place bid')
										}}</b-button>
									</div>
									<div class="control is-hidden-mobile">
										<b-button v-on:click="getProduct(0)" type="is-primary" outlined icon-left="sync-alt">{{
											$t('Refresh')
										}}</b-button>
									</div>
								</b-field>
								<div class="is-hidden-tablet">
									<b-button v-on:click="refreshButton()" type="is-primary" outlined expanded icon-left="sync-alt">{{
										$t('Refresh')
									}}</b-button>
								</div>
							</div>
						</section>
						<template>
							<section v-if="$store.getters.loggedIn !== true" class="has-text-centered">
								<hr>
								<p class="has-text-danger">
									{{ $t('Please log in to place a bid.') }}
								</p>
								<router-link :to="{ name: 'Login' }" tag="b-button">
									{{ $t('Logging in') }}
								</router-link>
							</section>
						</template>
					</div>
				</div>
			</div>
			<div
				class="column column-other is-12-tablet is-10-desktop is-4-widescreen is-4-fullhd"
				v-if="product.description || product.long_description || product.Categories"
			>
				<div class="card">
					<div class="card-content">
						<!-- termék hosszú leírás -->
						<ProductDescription
							:long_description="product.long_description"
							:description="product.description"
						></ProductDescription>
						<!-- címkék -->
						<template v-if="product.Categories">
							<!-- category types: tag: 6, city: 5, region: 4, country: 3, continent: 2, category: 1 -->
							<h2 class="title">{{ $t('Categories') }}</h2>
							<div class="buttons buttons-tags">
								<div v-for="(category, index) in product.Categories" :key=index>
									<b-button
										size="is-small"
										:key="index"
										v-if="category.type === 1"
										@click="putLocalStorage(category)"
									>
										<span v-if="$i18n.locale == 'hu'">{{ category.name }}</span>
										<span v-else>{{ category.languages.en ? category.languages.en : category.name }}</span>
									</b-button>
								</div>
							</div>
							<div v-if="product.Categories.length > 1">
								<h2 class="title">{{ $t('Tags') }}</h2>
								<div class="buttons buttons-tags">
									<div v-for="(category, index) in product.Categories" :key=index>
										<b-button
											size="is-small"
											v-if="category.type !== 1"
											@click="putLocalStorage(category)"
										>
											<span v-if="$i18n.locale == 'hu'">{{ category.name }}</span>
											<span v-else>{{ category.languages.en ? category.languages.en : category.name }}</span>
										</b-button>
									</div>
								</div>
							</div>
							<div v-if="product.year_from || product.year_to">
								<h2 class="title has-half-margin">{{ $t('Dates') }}</h2>
								<div>
									<span v-if="product.year_from == product.year_to">{{ product.year_to }}</span>
									<span v-else>{{ product.year_from }} - {{ product.year_to }}</span>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<!-- licit lista -->
		<template v-if="product.Bid">
			<b-modal :active.sync="isBetModalActive" has-modal-card :can-cancel="true">
				<ProductBid :_product="product"></ProductBid>
			</b-modal>
		</template>
	</section>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ProductGallery from '@/components/frontend/products/ProductGallery.vue'
import ProductForm from '@/components/frontend/products/ProductForm.vue'
import ProductBid from '@/components/frontend/products/ProductBid.vue'
import ProductDescription from '@/components/frontend/products/ProductDescription'

export default {
	name: 'Product',
	components: {
		Loading,
		ProductGallery,
		ProductForm,
		ProductBid,
		ProductDescription,
	},
	metaInfo () {
		return {
			title: this._metaTitle,
			titleTemplate: '%s | ' + this.$t('HT Auction'),
			meta: [
				{ name: 'description', content: (this.product.description) ? this._metaTitle + ' - ' + this.product.description : this._metaTitle },
				{ name: 'keywords', content: this.loading ? this.$t('Loading…') : (this._metaKeywords ? this._metaKeywords : 'keywords') },
				// OpenGraph data (Most widely used)
				{property: 'og:title', content: this._metaTitle +' | '+ this.$t('HT Auction') },
				{property: 'og:site_name', content: this.$t('HT Auction')},
				// The list of types is available here: http://ogp.me/#types
				{property: 'og:type', content: 'website'},
				// Should the the same as your canonical link, see below.
				{property: 'og:url', content: window.location.href },
				{property: 'og:image', content: window.location.origin +'/'+ this._metaImage},
				// Often the same as your meta description, but not always.
				{property: 'og:description', content: this.product.description},

				// Twitter card
				{name: 'twitter:card', content: 'summary'},
				{name: 'twitter:site', content: this.product.name +' | '+ this.$t('HT Auction') },
				{name: 'twitter:title', content: this._metaTitle +' | '+ this.product.name},
				{name: 'twitter:description', content: this.product.description},

				// Google / Schema.org markup:
				{itemprop: 'name', content: this._metaTitle +' | '+ this.$t('HT Auction') },
				{itemprop: 'description', content: this.product.description},
				{itemprop: 'image', content: window.location.origin +'/'+ this._metaImage},
				{name: 'robots', content: 'index, follow'}

			],
			link: [
				{rel: 'canonical', href: window.location.href}
			],
		}
	},
	data() {
		return {
			backendUrl: this.$backendUrl,
			product: {
				Bid: {
					Auction: {},
				},
				Images: {},
			},
			timerIsRun: false,
			durationTime: 0,
			heartbeat: 0,
			beatcounter: 0,
			currency: localStorage.getItem('currency') || 'HUF',
			currency_sign: '',
			images: [],
			metaimage: '',
			bid: { User: { UserPreference: { name: '' }, bidder_name: '' } },
			winner_user: { id: null, name: null },
			winnerChanged: false,
			lastBet: { price: 0 },
			new_bid: {
				price: 0,
				currency: localStorage.getItem('currency') || 'HUF',
			},
			firstBid: 0,
			productLoaded: false,
			isConnected: false,
			isBetModalActive: false,
			socketMessage: '',
			msg: 'response',
			time: this.$moment(),
			countdown: 0,
			user: this.$store.getters.userid,
			isWishlisted: false,
			loading: true,
			isModalActive: false,
			modalData: Object,
			showModal: false,
			testMessage: 'teszt üzenet',
			userMessages: [
				{ message1: 'Your bid is winning now.' },
				{ message2: 'You were overbid.' },
				{ message3: 'Bid placed.' },
			],
			bidPrice: 0,
			buttons: [
				// {
				//   title: "Send to friend",
				//   modaltitle: "Share this product",
				//   icon: "envelope",
				//   class: "is-primary button is-small is-outlined",
				//   email: "email",
				//   type: "share",
				//   sent: "Email sent to the recipient"
				// },
				{
					title: 'Ask about product',
					modaltitle: 'Ask about this product',
					icon: 'question',
					class: 'is-primary button is-outlined',
					tooltipclass: 'is-primary',
					email: 'email2',
					type: 'askaboutproduct',
					sent: 'Thank you for your question, we get back to you soon',
				},
				{
					title: 'Absentee bid placed',
					modaltitle: 'Place an absentee bid',
					icon: 'shopping-bag',
					class: 'is-primary button is-outlined',
					tooltipclass: 'is-primary',
					email: 'email3',
					type: 'purchase_order',
					sent: 'Your absentee bid has been sent',
				},
				{
					title: 'Report product',
					modaltitle: 'Report suspicious content',
					icon: 'flag',
					class: 'is-danger button is-outlined',
					tooltipclass: 'is-danger',
					email: 'email4',
					type: 'report_forgery',
					sent: 'Thank you for your report',
				},
			],
			has_success: false,
			has_error: false,
			fastbidUpdate: true,
			openingPrice: 0,
			openingBidstep: 0,
			fastBidEnabled: false,
		}
	},
	computed: {
		_metaTitle() {
			return this.$i18n.locale == 'hu'
				? this.product.name
				: typeof this.product.long_description != 'undefined' && this.product.long_description.en.name
					? this.product.long_description.en.name
					: this.product.name
		},
		_metaImage(){
			if (typeof this.product.Images[0] == 'undefined') {
				return "asset/placeholder_720.png"
			} else {
				return this.product.Images[0].filename
			}
		},
		_metaKeywords(){
			var i = 2;
			var cars = this.product.Categories;
			var len = cars.length;
			var text = "";
			for (; i < len; i++) {
				text += cars[i].name + ", ";
			}
			return text

		},
		fastbid1() {
			// if(this.fastbidUpdate){
			// 	console.log("fastbid_updated")
			// 	if (this.product.price > this.bidPrice) {
			// 		return this.product.price + this.openingBidstep - this.firstBid;
			// 	}
			// 	return this.bidPrice + this.openingBidstep - this.firstBid;
			// }
			return this.openingPrice + this.openingBidstep - this.firstBid
		},
		fastbid2() {
			// if(this.fastbidUpdate){
			// 	console.log("fastbid_updated")
			// 	if (this.product.price > this.bidPrice) {
			// 		return this.product.price + this.openingBidstep * 2 - this.firstBid;
			// 	}
			// 	return this.bidPrice + this.openingBidstep * 2 - this.firstBid;
			// }
			return this.openingPrice + this.openingBidstep * 2 - this.firstBid
		},
		fastbid3() {
			// if(this.fastbidUpdate){
			// 	console.log("fastbid_updated")
			// 	if (this.product.price > this.bidPrice) {
			// 		return this.product.price + this.openingBidstep * 3 - this.firstBid;
			// 	}
			// 	return this.bidPrice + this.openingBidstep * 3 - this.firstBid;
			// }
			return this.openingPrice + this.openingBidstep * 3 - this.firstBid
		},
		is_winner() {
			if (this.bid.winner_id != null && this.winner_user.id == this.$store.getters.userid) {
				return true
			} else {
				return false
			}
		},
		is_winner_user() {
			if (this.bid.winner_id == null) {
				return
			} else {
				return this.winner_user.name
			}
		},
		flashClass: function () {
			if (this.bid.winner_id == null || this.time.diff(this.product.Bid.finish) > 0) {
				return { card: true }
			} else {
				return {
					card: true,
					'has-success': this.is_winner || this.lastBet.user_id == this.$store.getters.userid,
					'has-error': !this.is_winner,
				}
			}
		},
	},
	methods: {
		fastBidEnable(){
			const fbv = localStorage.getItem('fastbid');
			if(fbv == 'true'){
				localStorage.setItem('fastbid', false);
			}else{
				localStorage.setItem('fastbid', true);
			}
		},
		hufToCurrency(val) {
			return this.$options.filters.toCeil(this.$options.filters.fromToCurrency(val, this, 'HUF', this.currency))
		},
		refreshButton() {
			this.fastbidUpdate = true
			this.getProduct(0)
		},
		getProduct(source) {
			console.log('getProduct()')
			var _this = this
			setTimeout(function () {
				_this.$http.get('/product/' + _this.$route.params.id).then((response) => {
					console.log('RES:', response.data)
					_this.product = response.data.product
					if (_this.$store.getters.loggedIn) {
						_this.GetFavorite(_this.$route.params.id)
					}

					_this.product.long_description = response.data.product.long_description
						? response.data.product.long_description
						: {
							en: {
								name: response.data.product.name,
								description: response.data.product.description,
							},
						}

					// redirect if auction is invisible and not admin
					if (response.data.product.Bid.Auction.status == 'invisible' && _this.$store.getters.role !== 100) {
						_this.$router.push({ name: 'Products' })
					}
					if (response.data.product.Bid) {
						_this.bid = response.data.product.Bid
						if (response.data.product.Bid.User) {
							_this.winner_user.id = response.data.product.Bid.User.id
							_this.winner_user.name = response.data.product.Bid.User.UserPreference.name
						} // else { }
						_this.firstBid = 0
						if (!_this.bid.winner_id) {
							_this.firstBid = _this.bid.bid_step
						}
						if (source != 5) {
							_this.new_bid.price = _this.hufToCurrency(
								(_this.bid.price > _this.product.price ? _this.bid.price : _this.product.price) +
									_this.bid.bid_step -
									_this.firstBid
							)
						}
					}
					_this.images = response.data.product.Images
					if (response.data.product.long_description) {
						if (typeof response.data.product.long_description !== 'object') {
							_this.product.long_description = response.data.product.long_description
								? JSON.parse(response.data.product.long_description)
								: {}
						} else {
							_this.product.long_description = response.data.product.long_description
						}
					}
					_this.bidPrice = response.data.product.Bid.price
					_this.openingPrice = response.data.product.Bid.price
					_this.openingBidstep = response.data.product.Bid.bid_step
					//console.log("list of images:" + _this.Images);
					_this.loading = false
					_this.productLoaded = true
					_this.fastbidUpdate = false
					_this.fastBidEnabled = localStorage.getItem('fastbid')=='true'?true:false;
				}).
					catch(()=>{
						_this.loading = false;
					})
			}, 100)
		},
		putLocalStorage(category) {
			var _this = this
			console.log('CATEGORY SELECTED', category)
			localStorage.setItem('category', JSON.stringify(category))
			if (category.type == 1) {
				_this.$router.push({
					name: 'ProductsByCategory',
					params: { maincategory: category.id,
						title: category.title
					},
				})
			} else {
				_this.$router.push({ name: 'Products' })
			}
		},
		sendLicit(newprice, currency) {
			this.fastbidUpdate = true
			console.log('LASTBET PRICE:', this.lastBet.price, newprice)

			//e.preventDefault();
			var _this = this
			_this.user = _this.$store.getters.userid
			console.log(_this.$store.user)
			this.new_bid.currency = currency
			this.new_bid.price = newprice
			console.log('user bid::::', this.user, this.new_bid)
			console.log('LASTBET PRICE:', this.lastBet.price)
			var currentPrice = this.bid.price > this.product.price ? this.bid.price : this.product.price
			console.log('PRODUCT PRICE:', this.product.price)
			console.log('BID     PRICE:', this.bid.price)
			console.log('CURRENT PRICE:', currentPrice)
			var temp_lastbet_price = _this.lastBet.price
			// if(this.convertTo(currentPrice)>this.convertTo(this.new_bid.price)){
			//   _this.$buefy.snackbar.open({
			//     message: _this.$t("bid.BET_PRICE_LOWER_THAN_PRICE"),
			//     //message: _this.$t("NAGYOBB KELL"),
			//     type: "is-warning",
			//     duration: 3500,
			//     queue: false,
			//   });
			// }else{

			this.$socket.emit(
				'sendLicit',
				{
					user: { id: _this.user, token: localStorage.getItem('token') },
					product: _this.product,
					bid: _this.product.Bid,
					new_bid: _this.new_bid,
				},
				function (data) {
					console.log('$respLicit():', data)
					console.log('data.err:', data.err)
					if (data.err == 'LOWPRICE') {
						_this.getProduct(1)
					}
					console.log('winner', _this.winner_user)
					var hasError = !!data.err
					_this.has_success = !hasError
					_this.has_error = hasError
					// if (data.last_bet != null) {
					// 	_this.lastBet = data.last_bet;
					// }
					if (data.err !== 'LOWPRICE') {
						_this.lastBet.price = _this.$options.filters.fromToCurrency(newprice, _this, _this.currency, 'HUF')
					}

					//_this.lastBet.price = newprice;
					console.log('LASTBET PRICE:', _this.lastBet.price)

					const winner_id = data.winner.id
					const winner_name = data.winner.name
					_this.winner_user.id = data.winner.id
					_this.winner_user.name = data.winner.name

					console.log('WINNER', winner_id)
					console.log('WINNER USER', winner_name)
					console.log('USER', _this.user)
					_this.product.Bid.bid_step = data.bidStep
					_this.bid.bid_step = data.bidStep
					_this.bidStep = data.bidStep
					_this.bid.price = data.data.price
					_this.product.Bid.winner_id = winner_id
					//_this.winner_name = data.winner.name;
					// feedback
					var msg = 'bid.' + data.message
					if (!data.err) {
						if (_this.user == winner_id) {
							msg = 'Your bid is winning now.'
							_this.getProduct(2)
						} else {
							msg = 'You were overbid.'
							if (data.message == 'BID_FINISHED') {
								_this.lastBet.price = temp_lastbet_price
							}
							_this.getProduct(3)
						}
					}

					_this.$buefy.snackbar.open({
						message: _this.$t(msg),
						type: !data.err && _this.user == winner_id ? 'is-success' : 'is-warning',
						duration: !data.err && _this.user == winner_id ? 3500 : 5000,
						queue: false,
					})
				}
			)
			// }
		},
		modalOpen: function (data) {
			this.modalData = data
			//console.log(data.email);
			this.isModalActive = true
		},
		AddToFavorites(bid) {
			console.log('BID:', bid.Wishlist)
			var _this = this
			_this.$http
				.post('user/watch', {
					bid_id: bid.id,
					is_watch: _this.isWishlisted ? 0 : 1,
				})
				.then((response) => {
					_this.bid.Wishlist = response.data.wishlist
					_this.isWishlisted = response.data.wishlist !== null && response.data.wishlist.is_watch == 1
					let msg = _this.$t('Removed from favorites')
					if (response.data.wishlist.is_watch) {
						msg = _this.$t('Added to favorites')
					}
					_this.$buefy.snackbar.open({
						message: msg,
						queue: false,
					})
				})
				.catch((error) => {
					_this.$buefy.snackbar.open({
						message: _this.$t('Failed to add to favorites'),
						type: 'is-danger',
						duration: 5000,
						queue: false,
					})
					console.log(error)
				})
		},
		GetFavorite(id) {
			var _this = this
			this.$http
				.get('user/watch/' + id)
				.then((response) => {
					console.log('########## getfavorite:', response)
					_this.isWishlisted = response.data.wishlist !== null && response.data.wishlist.is_watch == 1
					if (response.data.wishlist) {
						_this.fastbidUpdate = response.data.wishlist.is_bid
					}
				})
				.catch((error) => {
					console.log(error)
				})
		},
		GetLastBet() {
			var _this = this
			this.$socket.emit(
				'lastLicit',
				{
					bid_id: _this.$route.params.id,
					user: { id: _this.user, token: localStorage.getItem('token') },
				},
				function (data) {
					console.log('lastLicit', data)
					if (data != null) {
						_this.lastBet = data
					} else {
						_this.lastBet = { price: 0 }
					}
				}
			)
		},
		convertTo(val) {
			return this.$options.filters.toCeil(this.$options.filters.fromToCurrency(val, this, 'HUF', this.currency))
		},
		calcRemainingTime() {
			// console.log('calcRemainingTime()')
			const __this = this
			this.time = this.$moment().add(this.durationTime) //.format('YYYY-MM-DD HH:mm:ss');
			//console.log("duration prod:", this.durationTime.as('milliseconds'), this.time.milliseconds())
			//console.log('LOCAL TIME', _this.time.format('HH:mm:ss.SSS'))
			if (this.timerIsRun) {
				setTimeout(function () {
					__this.calcRemainingTime(__this)
				}, 1100 - __this.time.milliseconds())
			}
		},
		startWatchdog() {
			var _this = this
			_this.heartbeat++;
			if (_this.heartbeat > 2) {
				_this.timerIsRun = false
			} else {
				_this.timerIsRun = true
			}
			// console.log('woof');
			setTimeout(_this.startWatchdog, 1000);
		}
	},

	mounted() {
		var _this = this
		this.sockets.subscribe('bid_' + this.$route.params.id, (data) => {
			console.log('bid_' + this.$route.params.id, data)
			_this.winner_user.id = data.winner.id
			_this.bid.winner_id = data.winner.id
			_this.winner_user.name = data.winner.name
			_this.bid.User = data.winner
			_this.bid.price = data.data.price
			_this.bid.bid_step = data.bidStep
		})
		this.GetLastBet()
		//this.$socket.disconnect();
		//this.$socket.connect();
		console.log('product mounted', _this.$store.getters.token)
		// setInterval(function(){
		// 	if(_this.$socket.disconnected){
		// 		_this.$socket.connect();
		// 	}
		// 	console.log("socket", _this.$socket)
		// 	//_this.$socket.socket.reconnect();
		// },1000);
		// this.$checkLoggedIn(this, ()=>{
		// 	this.$socket.emit("exchange", localStorage.getItem("token"));
		// })

		// console.log("LOGGED IN=", this.$store.getters.loggedIn);
		if (_this.$store.getters.currencies['huf']) {
			this.getProduct(4)
		} else {
			// eslint-disable-next-line no-unused-vars
			_this.$store.subscribe((mutation, state) => {
				//console.log('[[[[[[',mutation);
				//console.log(']]]]]]',state);
				if (mutation.type == 'setCurrencies') {
					this.getProduct(4)
				}
			})
		}
		// this.startWatchdog();
		setTimeout(this.startWatchdog, 2000);
	},

	sockets: {
		connect() {
			console.log('$connect()')
			// Fired when the socket connects.

			this.isConnected = true
			console.log('connect')
			// this.$socket.emit("exchange", localStorage.getItem("token"));
		},
		respCheck(b) {
			console.log('respCheck', new Date(b.iat * 1000), new Date(b.exp * 1000))
		},
		respExchange(b) {
			console.log('$respExchange():', b, this.$store.getters.token)
			this.$socket.emit('exchange', this.$store.getters.token)
		},
		respProductUpdated() {
			console.log('product updated')
		},

		disconnect() {
			this.isConnected = false
			console.log('disconnect')
		},
		respLicit(data) {
			console.log('$resp global licit():', data)
			this.bid.bid_step = data.bidStep
			if (data['data']) {
				this.bid.price = data.data.price
			}
			this.new_bid.price = this.hufToCurrency(this.bid.price + data.bidStep)
		},
		serverTime(data) {
			var _this = this
			console.log('PRODUCT SERVER TIME', data)
			if (_this.beatcounter > 60 || _this.timerIsRun == false) {
				const servertime = _this.$moment(data)
				if (_this.beatcounter == 0) {
					_this.durationTime = _this.$moment.duration(servertime.diff(this.$moment()))
				}
				_this.timerIsRun = true
				_this.calcRemainingTime(_this)
				_this.beatcounter = 0
				_this.getProduct(5)
			}
			_this.heartbeat = 0
			_this.beatcounter++
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css">
.column-bid .card,
.column-other .card {
	height: 100%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	/* display: none; <- Crashes Chrome on hover */
	-webkit-appearance: none;
	margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type='number'] {
	-moz-appearance: textfield; /* Firefox */
}

.has-success {
	animation-name: flash_success;
	animation-duration: 0.6s;
}

.has-error {
	animation-name: flash_warning;
	animation-duration: 0.6s;
}

@keyframes flash_success {
	from {
		background-color: green;
	}
	to {
		background-color: #ff000000;
	}
}
@keyframes flash_warning {
	from {
		background-color: red;
	}
	to {
		background-color: #ff000000;
	}
}
.carousel-indicator {
	overflow: auto;
}

.v-center {
	top: -1px;
	position: absolute;
}

.buttons-actions .button {
	margin-bottom: 0;
}
.card-content .b-tooltip {
	margin-right: 0.5rem;
	margin-bottom: 0.5rem;
}
.card-content .b-tooltip:last-child,
.card-content .b-tooltip.is-hidden-tablet {
	margin-right: 0;
}

@media screen and (max-width: 768px) {
	.buttons-fastbid,
	.buttons-fastbid .button {
		display: block;
	}
	.buttons-fastbid .button {
		width: 100%;
		border-radius: 4px !important;
		margin-bottom: 0.5rem;
	}

	.field.is-grouped > .control.place-bid {
		margin-right: 0;
	}
}
@media screen and (min-width: 769px) {
	.buttons-fastbid .button {
		width: calc(100% / 3);
	}
}

.button.back {
	position: absolute;
	top: 0.75em;
	z-index: 10;
}
.user-message {
	margin: 1.25rem;
}

.buttons.buttons-tags:last-child {
	margin-bottom: 1rem;
}

.buttons-tags > div:not(:last-child) > button {
	margin-right: 0.5rem;
}

.content .columns.is-gapless {
	margin-bottom: 0;
}
.content .column.has-text-right {
	align-self: flex-end;
}

.counter-title {
	margin-top: 0em !important;
}
.counter-title, .is-danger {
	text-color: red;
}

.has-half-margin {
	margin-bottom: 0.75rem !important;
}
.price-box {
	margin-bottom: 0.6666em !important;
}

.is-mg-right-1 {
	margin-right: 0.2rem !important;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
